import { css } from "@emotion/react";

type SpacerProps = {
    scale: number;
    fill?: boolean;
    mark?: boolean;
};

export default function Spacer(props: SpacerProps) {
    const { scale, fill, mark } = props;
    const style = css({
        height: `var(--rs-unit-x${scale})`,
        flexGrow: fill ? 1 : 0,
        flexShrink: fill ? 1 : 0,
        backgroundColor: mark ? "red" : "transparent",
    });
    return <div css={style} />;
}
